import { Link } from 'react-router-dom';

export default function BuilderLabSection() {
  return (
    <section className="sec g">
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>반복되는 업무를 나만의 흐름으로</small>
            <h2>
              드래그로 연결해서 만드는
              {' '}
              <em>AI Agent</em>
            </h2>
          </div>
          <Link className="more" to="/product#s3">
            자세히보기
            <svg className="i">
              <use href="#arr" />
            </svg>
          </Link>
        </div>
        <div className="lab rv d1">
          <div className="pal">
            <h4>기능 선택</h4>
            <p>필요한 기능(노드)을 골라 업무 흐름에 추가합니다.</p>
            <small>트리거</small>
            <button data-k="sch">
              <i style={{ background: "var(--org)" }}>
                <svg className="i">
                  <use href="#clock" />
                </svg>
              </i>
              스케줄
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
            <button data-k="chat">
              <i style={{ background: "var(--grn)" }}>
                <svg className="i">
                  <use href="#msg" />
                </svg>
              </i>
              채팅 시작
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
            <small>액션</small>
            <button data-k="ai">
              <i style={{ background: "var(--pnk)" }}>
                <svg className="i">
                  <use href="#spark" />
                </svg>
              </i>
              AI 응답 (LLM)
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
            <button data-k="doc">
              <i style={{ background: "var(--blu)" }}>
                <svg className="i">
                  <use href="#doc" />
                </svg>
              </i>
              문서 검색
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
            <button data-k="judge">
              <i style={{ background: "#F97316" }}>
                <svg className="i">
                  <use href="#branch" />
                </svg>
              </i>
              판단
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
            <button data-k="send">
              <i style={{ background: "var(--ac)" }}>
                <svg className="i">
                  <use href="#send" />
                </svg>
              </i>
              답변 전송
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
            <small>커넥터</small>
            <button data-k="mail">
              <i style={{ background: "var(--ac)" }}>
                <svg className="i">
                  <use href="#mail" />
                </svg>
              </i>
              이메일 커넥터
              <em>
                <svg className="i">
                  <use href="#plus" />
                </svg>
              </em>
            </button>
          </div>
          <div className="cvs">
            <div className="tb2">
              AcXion-On · 워크플로우 빌더
              <span className="st">
                <i />
                <b>편집 중</b>
              </span>
              <span className="sp" />
              <button className="replay" data-reset="">
                <svg className="i">
                  <use href="#replay" />
                </svg>
                초기화
              </button>
              <button className="btn p sm" data-run="" style={{ height: "32px", fontSize: "13px" }}>
                <svg className="i" style={{ width: "13px", height: "13px" }}>
                  <use href="#play" />
                </svg>
                실행
              </button>
            </div>
            <div className="flow">
              <div className="empty">
                <svg className="i">
                  <use href="#plus" />
                </svg>
                기능을 드래그해서 여기에 놓으세요
              </div>
            </div>
            <div className="res toast" style={{ position: "absolute" }}>
              <i>
                <svg className="i">
                  <use href="#check" />
                </svg>
              </i>
              워크플로우 실행 완료
            </div>
          </div>
        </div>
        <div className="pnote rv">
          <span>왼쪽 기능을 드래그해서 흐름에 놓고, 실행해보세요.</span>
        </div>
      </div>
    </section>
  );
}
